import { IntentProps } from '../../../core/slots/Intent/Intent.js';
import {
  ChartToolbarConfig,
  DraggableToolbarProps,
} from '../../core/types/toolbar.js';

/** Props for the Toolbar Slot in the HistogramChart
 * @public
 */
export type HistogramToolbarSlotProps = DraggableToolbarProps;

/**
 * Properties configurable by HistogramConfiguration Provider
 * @public
 */
export type HistogramToolbarConfig = HistogramToolbarSlotProps & {
  intents?: Array<IntentProps>;
};

export interface HistogramToolbarInternalProps
  extends HistogramToolbarSlotProps,
    ChartToolbarConfig {
  intents?: Array<IntentProps>;
}

export const defaultToolbarInternalConfig: HistogramToolbarInternalProps = {
  hidden: false,
  intents: [],
  placement: 'top-right',
  collapsed: false,
  draggable: false,
};
